import { TemplateElement, defineElement, html } from '@webtides/element-js';

class PriceAsterisk extends TemplateElement {
    get isBrand() {
        return window.siteConfig()?.isBrand ?? false;
    }

    get isShop() {
        return window.siteConfig()?.isShop ?? false;
    }

    get showPriceAsterisk() {
        return !this.isShop && this.isBrand;
    }

    template() {
        return this.showPriceAsterisk ? '*' : '';
    }
}

defineElement('price-asterisk', PriceAsterisk);
